export default [
  {
    "id": 1,
    "label": "Affaires municipales"
  },
  {
    "id": 2,
    "label": "Agriculture, P\u00eacheries et Alimentation"
  },
  {
    "id": 7,
    "label": "Classe moyenne"
  },
  {
    "id": 3,
    "label": "Culture et Francophonie"
  },
  {
    "id": 5,
    "label": "\u00c9conomie, Science et Innovation"
  },
  {
    "id": 6,
    "label": "\u00c9ducation"
  },
  {
    "id": 12,
    "label": "Gestion des finances publiques"
  },
  {
    "id": 8,
    "label": "Immigration"
  },
  {
    "id": 16,
    "label": "Inscription \u00e0 l'infolettre"
  },
  {
    "id": 35,
    "label": "Int\u00e9grit\u00e9"
  },
  {
    "id": 17,
    "label": "Interne"
  },
  {
    "id": 9,
    "label": "Justice et S\u00e9curit\u00e9 publique"
  },
  {
    "id": 10,
    "label": "Nationalisme et Souverainet\u00e9"
  },
  {
    "id": 11,
    "label": "Sant\u00e9 et Services sociaux"
  },
  {
    "id": 13,
    "label": "Tourisme et international"
  },
  {
    "id": 14,
    "label": "Transports"
  },
  {
    "id": 15,
    "label": "Travail, Emploi et Solidarit\u00e9 sociale"
  },
  {
    "id": 4,
    "label": "Vert"
  }
]
